import { render, staticRenderFns } from "./RenShi4.vue?vue&type=template&id=7fd9867c&scoped=true&"
import script from "./RenShi4.vue?vue&type=script&lang=js&"
export * from "./RenShi4.vue?vue&type=script&lang=js&"
import style0 from "./RenShi4.vue?vue&type=style&index=0&id=7fd9867c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd9867c",
  null
  
)

export default component.exports